<div class="sidenav" fxLayout="column">

  <!-- Layout: Alpha -->
  <div class="header" fxLayout="row" fxLayoutAlign="start center" *ngIf="layout === 'alpha'">

    <img class="logo" alt="logo" src="assets/img/nuvola_logo.png">
    <span fxFlex></span>

    <div class="actions" fxLayout="row" fxLayoutAlign="start center">
      <button class="toggle" type="button" mat-icon-button (click)="toggleSidenavCollapse()" *ngIf="collapsed">
        <mat-icon>radio_button_unchecked</mat-icon>
      </button>
      <button class="toggle" type="button" mat-icon-button (click)="toggleSidenavCollapse()" *ngIf="!collapsed">
        <mat-icon>radio_button_checked</mat-icon>
      </button>
    </div>
  </div>
  <!-- /Layout: Alpha -->

  <elastic-scrollbar class="menu" fxFlex>

    <div class="heading" fxLayout="row" fxLayoutAlign="space-between center">
      <div class="name">Navigation</div>

      <!-- Layout: Beta -->
      <div class="actions" *ngIf="layout === 'beta'">
        <button class="toggle" type="button" mat-icon-button (click)="toggleSidenavCollapse()" *ngIf="collapsed">
          <mat-icon>radio_button_unchecked</mat-icon>
        </button>
        <button class="toggle" type="button" mat-icon-button (click)="toggleSidenavCollapse()" *ngIf="!collapsed">
          <mat-icon>radio_button_checked</mat-icon>
        </button>
      </div>
      <!-- /Layout: Beta -->

    </div>

    <div class="sidenav-item-holder" *ngFor="let item of sidenavItems$ | async" >
      <elastic-sidenav-item class="sidenav-item-container" [item]="item" *accessControl="{id:item.getPermission()}" [currentlyOpen]="currentlyOpen$ | async" ></elastic-sidenav-item>
    </div>

  </elastic-scrollbar>

</div>
